import { first, Observable, switchMap, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    // const token = this.oidcSecurityService.getAccessToken();
    // console.log('token', token);
    const url = state.url;
    //console.log('running login guard');
    return this.authService.checkAuth().pipe(
      switchMap(() => {
        return this.authService.signedIn$;
      }),
      tap((isAuthenticated) => {
        if (!isAuthenticated) {
          this.authService.pushTmpUrl(url);
          this.router.navigateByUrl('auth/login');
        } else {
          const url = this.authService.popTmpUrl();
          if (url) {
            this.router.navigateByUrl(url);
          }
        }
      }),
      first(),
    );
  }
}
